@for (kpiByCategory of kpisByCategory; track kpiByCategory.category) {
  <kpi-card
    [category]="kpiByCategory.category"
    [kpis]="kpiByCategory.kpis"
    [keyMilestones]="keyMilestones"
  >
  </kpi-card>
}
